/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {FormsModule} from '@angular/forms';
import * as _ from 'lodash';

import template from './team-selector.component.html';
import {APP_SHARED} from '../app-shared';

@Component({
  standalone: true,
  imports: [...APP_SHARED, FormsModule],
  selector: 'adn-team-selector',
  template
})
export class AdnTeamSelectorComponent implements OnChanges {
  @Input() teams: any[];
  @Input() teamsWarning: any;
  @Input() model: any;
  @Input() param = 'teams';
  @Output() changed = new EventEmitter<void>();

  expanded = false;
  teamNames: Record<string, any> = {};

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.teams) {
      this.indexTeams();
    }
  }

  get selectedTeamIds(): string[] {
    return _.get(this.model, this.param) || [];
  }

  trackByTeamId(_index: number, team: any): string {
    return team.id;
  }

  isTeamSelected(teamId: string): boolean {
    return this.selectedTeamIds.indexOf(teamId) > -1;
  }

  toggleTeam(teamId: string, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    const teams = [...this.selectedTeamIds];
    const index = teams.indexOf(teamId);

    if (checked && index < 0) {
      teams.push(teamId);
    } else if (!checked && index > -1) {
      teams.splice(index, 1);
    }

    this.model[this.param] = teams;
    this.changed.emit();
  }

  private indexTeams(): void {
    this.teamNames = _.keyBy(this.teams || [], (team: any) => team.id);
  }
}
